export const ToggleVariants = {
  dot: {
    active: { x: 28, transition: { ease: [0.25, 0.1, 0.25, 1] } },
    inActive: { x: 0, transition: { ease: [0.25, 0.1, 0.25, 1] } },
  },
};
